import React from "react";

interface CompleteIconProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string | number;
}

const CompleteIcon: React.FC<CompleteIconProps> = ({
  className = "",
  width = 10,
  height = 12,
  fill = "black",
  fillOpacity = "0.2",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.26667 1.33333L6.10667 0.533333C6.04667 0.226667 5.77333 0 5.45333 0H0.666667C0.3 0 0 0.3 0 0.666667V10.6667C0 11.0333 0.3 11.3333 0.666667 11.3333C1.03333 11.3333 1.33333 11.0333 1.33333 10.6667V6.66667H5.06667L5.22667 7.46667C5.28667 7.78 5.56 8 5.88 8H9.33333C9.7 8 10 7.7 10 7.33333V2C10 1.63333 9.7 1.33333 9.33333 1.33333H6.26667Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};

export default CompleteIcon;
